import { isAppointmentScheduled } from 'Data/format.js'

export function getView(appointment) {
  return !isAppointmentScheduled(appointment)
}
